import { freshLeaks } from '@/mocks/homeData';
import SectionHeading from '@/pages/home/components/SectionHeading';

const heatStyle: Record<string, string> = {
  热: 'bg-primary-100 text-primary-700',
  新: 'bg-accent-100 text-accent-900',
};

export default function FreshLeaks() {
  return (
    <section id="leaks" className="border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="新鲜爆料"
          title="刚出锅的爆料，先看标题再决定信不信"
          desc="这一区只放刚冒头、还没定性的消息；标题已经写清关键点，点进去有出处和后续进展。"
          action={
            <span className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-500">
              <i className="ri-information-line"></i>
              未经证实的内容已单独标注
            </span>
          }
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {freshLeaks.map((leak) => (
            <article
              key={leak.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition hover:border-accent-300"
            >
              <div className="flex items-center justify-between">
                <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                  {leak.tag}
                </span>
                <span
                  className={`rounded-md px-2 py-0.5 text-xs font-bold ${heatStyle[leak.heat] ?? 'bg-background-200 text-foreground-700'}`}
                >
                  {leak.heat}
                </span>
              </div>

              <h3 className="mt-3 text-base font-bold leading-snug text-foreground-950">{leak.title}</h3>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">{leak.summary}</p>

              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-time-line"></i>
                  {leak.time}
                </span>
                <span className="flex items-center gap-1 text-xs font-medium text-primary-600">
                  看后续
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}